/**
 *@version 1.0.0
 *@author haozg
 *@createTime 2022/1/13
 *@updateTime 2022/1/13
 @description 混入 自动填充div高度,使其撑满可视区域
 @example html <div class="jsAutoFillDIV" :style="autoFillStyle">
 */

export default {
  data() {
    return {
      // 最小高度
      minHeight: 0
    }
  },
  computed: {
    autoFillStyle() {
      if (this.dataList.length > 0) {
        return  'min-height:0;'
      }
      return `min-height: ${this.minHeight < 300 && this.dataList.length === 0 ? 300 : this.minHeight}px;`
    }
  },
  mounted() {
    window.addEventListener('resize', this.autoFillResizeHandle);
    const timer = setTimeout(() => {
      // 设置div的高度
      this.setAutoFillDIVHeight();
      clearTimeout(timer);
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.autoFillResizeHandle);
  },
  methods: {
    // resize
    autoFillResizeHandle() {
      // 设置div的高度
      this.setAutoFillDIVHeight();
    },
    //设置div的高度
    setAutoFillDIVHeight() {
      const dom = document.querySelector('.jsAutoFillDIV');
      if (dom) {
        const domRect = dom.getBoundingClientRect();
        // 16是底部的padding-bottom
        this.minHeight = window.innerHeight - domRect.top - 16;
      } else {
        this.minHeight = 0;
      }
    }
  }
};
